const {fieldType, fields, FIELD_NAME} = require("./fields");
const lodash = require("lodash");
const {PostCodeService} = require("../services");
const {
    regexPostalCode,
    message_post_code_invalid,
    message_post_code_not_exist,
    message_post_code_required_dash,
    message_fullwidth
} = require("../utils/contains");
const {checkFullwidth} = require("../utils/check-fullwidth");


$(document).ready(function () {
    $('#wrap-info').show();
    $('#methodPay').hide();

    $('#formDonateData').submit(function () {
        $('#btnSubmit').prop('disabled', true);
    });

    function eventFieldForm() {
        $(".datepicker").datepicker();
        fields.forEach(function (field) {
            if (
                field.type === fieldType.INPUT ||
                field.type === fieldType.TEXTAREA
            ) {
                $(`#${field.name}`).keyup(
                    lodash.debounce(function () {
                        $(`#error_${field.name}`).empty();
                    }, 200)
                );
            }
            if (field.type === fieldType.CHECKBOX) {
                $(`#${field.name}`).change(
                    lodash.debounce(function () {
                        $(`#error_${field.name}`).empty();
                    }, 200)
                );
            }
            if (field.type === fieldType.RADIO) {
                $(`input[name=${field.name}]`).on(
                    "change",
                    lodash.debounce(function () {
                        $(`#error_${field.name}`).empty();
                    }, 200)
                );
            }
            if (field.type === fieldType.DROPDOWN) {
                $(`#${field.name}`).change(
                    lodash.debounce(function () {
                        $(`#error_${field.name}`).empty();
                    }, 200)
                );
            }
            if (field.type === fieldType.INPUT_MONEY) {
                $(`#${field.name}`).keyup(
                    lodash.debounce(function () {
                        $(`#error_${field.name}`).empty();
                    }, 200)
                );
            }
        });
    }

    eventFieldForm();

    function handleProvinceCityStreet(selected) {
        const first = selected;
        $("#address_province").val(first.province);
        let str = first.city;
        if (first.street) {
            str += first.street;
        }
        $("#address").val(str);

        $("#error_address").remove();
    }

    function resetAddressCityStreet() {
        const work_address = `#${FIELD_NAME.address}`;
        $(work_address).val("");
    }

    function registerEventCheckedRadioAddressCityStreet() {
        $(`input[name=address_city_street]`).on(
            "change",
            function () {
                $('#message-error-listAddressCityStreet').empty();
            }
        );
    }

    function appendErrorPostalCode(isShow = true, message = message_post_code_not_exist) {
        $("#wrap_error_postal_code").empty();
        if (isShow) {
            $("#wrap_error_postal_code").append(
                `<div id="error_postal_code" class="error-system">${message}</div>`
            );
        }
    }

    function showModalChooseAddressCityStreet(list, callback) {
        $('#ModalChooseAddressCityStreet').modal('toggle');
        $('#message-error-listAddressCityStreet').empty();
        $('#listAddressCityStreet').empty();
        callback(list);
    }

    function registerButtonGetAddressCityStreet(list = [], callback) {
        $("#btnGetAddressCityStreet").on(
            'click',
            function () {
                const val = $('input[name=address_city_street]:checked').val();
                if (!val) {
                    $('#message-error-listAddressCityStreet').text("都道府県を入力してください。");
                    return;
                }

                const find = list.find(ele => ele.id === parseInt(val));
                if (find) {
                    callback(find);
                    $('#ModalChooseAddressCityStreet').modal('toggle');
                }
            });
    }

    function callbackShowModalChooseAddressCityStreet(list = [], callbackSelectedSuccess) {
        let html = '';
        list.forEach(ele => {
            html += `<div class="member-type-item form-check mt-2">
                       <input class="form-check-input" type="radio" name="address_city_street" id="address_city_street" value="${ele.id}">
                        <label class="form-check-label" for="address_city_street}">
                            ${ele.province + ' - ' + ele.city + ' - ' + ele.street}
                        </label>
                    </div>`;
        })

        $('#listAddressCityStreet').append(html);
        registerButtonGetAddressCityStreet(list, callbackSelectedSuccess);
        registerEventCheckedRadioAddressCityStreet()
    }

    function callbackSelectedSuccess1(selected) {
        handleProvinceCityStreet(selected);
    }

    $("#btnPostalCode").on(
        'click',
        function () {
            appendErrorPostalCode(false);
            const val = $('#postal_code').val();
            if (!val) return;
            try {
                checkFullwidth(val)
            } catch (e) {
                appendErrorPostalCode(true, message_fullwidth);
                return;
            }
            if (val.search('-') < 0) {
                appendErrorPostalCode(true, message_post_code_required_dash);
                return;
            }
            if (!regexPostalCode.test(val)) {
                appendErrorPostalCode(true, message_post_code_invalid);
                return;
            }

            PostCodeService.getInfoByCode(val).then(
                (response) => {
                    if (response && response.length > 0) {
                        showModalChooseAddressCityStreet(response, (list) => callbackShowModalChooseAddressCityStreet(list, callbackSelectedSuccess1));
                    } else {
                        // back to list default
                        resetAddressCityStreet();
                        // show error post_code invalid
                        appendErrorPostalCode();
                    }
                }
            );
        }
    )
});
